import { render, staticRenderFns } from "./ReviewBlockVestiging.vue?vue&type=template&id=634346c4"
import script from "./ReviewBlockVestiging.vue?vue&type=script&lang=js"
export * from "./ReviewBlockVestiging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../themes/custom/ef2_custom/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports